const AccountByFollowersReport = {

	visual: {
		icon: "va-icon fa fa-blind",
		title: "Accounts by followers",
		desc: "Specific accounts with more than {x} number of followers"
	},

	binding: [
	{"account_screen_name": "array","label":"Screen names"},
	{"minimum_followers": "number", "label":"Minimun followers"},
	{"account_limit": "number", "label":"Limit."}
	],

	query:`
		MATCH 
			(a:Account) 
		WHERE 
			a.screen_name IN :account_screen_name
		AND 
			a.followers_count > :minimum_followers 
		RETURN a LIMIT :account_limit
	`,

	config:{
		console_debug:true,
		labels: {
			"Account":{
				"caption": "screen_name",
				"size":"followers_count"
			},
		}
	}
	
}

export default AccountByFollowersReport;
